@if (showTitle) {
  <h3 class="scheduled-payment-details__subheader">Scheduled Item</h3>
}
<dl class="scheduled-payment-details__items">
  @if (showHeader) {
    <div class="scheduled-payment-details__item scheduled-payment-details__item--header">
      <dt class="scheduled-payment-details__label">Item</dt>
      <dd class="scheduled-payment-details__detail">Amount</dd>
    </div>
    <mat-divider></mat-divider>
  }
  <div class="scheduled-payment-details__item">
    <dt class="scheduled-payment-details__label" [matTooltip]="item.title">{{ item.title }}</dt>
    <dd class="scheduled-payment-details__detail">{{ item.amount | currency }}</dd>
  </div>
  @for (detail of item.details; track detail) {
    <div class="scheduled-payment-details__item">
      <dt class="scheduled-payment-details__label"
        [matTooltip]="detail.description">{{ detail.description }}</dt>
      <dd class="scheduled-payment-details__detail">{{ detail.value }}</dd>
    </div>
  }
  <mat-divider></mat-divider>
  <div class="scheduled-payment-details__item">
    <dt class="scheduled-payment-details__label">Subtotal</dt>
    <dd class="scheduled-payment-details__detail">{{ item.amount | currency }}</dd>
  </div>
  <div class="scheduled-payment-details__item">
    <!-- TODO (TOP-3034): Restore "Estimated " prefix when estimate display is configurable -->
    <dt class="scheduled-payment-details__label">Convenience Fee</dt>
    <dd class="scheduled-payment-details__detail">{{ item.convenienceFee | currency }}</dd>
  </div>
  <div class="scheduled-payment-details__item scheduled-payment-details__item--total">
    <dt class="scheduled-payment-details__label">Total</dt>
    <dd class="scheduled-payment-details__detail">{{ getTotalAmount() | currency }}</dd>
  </div>
</dl>
